import React, { FC } from 'react';
import './signup_user.scss';
import { SignUpCaptcha } from './captcha/SignUpCaptcha';
import { SignUpDiscovery } from './discovery/SignUpDiscovery';
import { SignUpForm } from './form/SignUpForm';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page } from '../../../components/page/Page';
import { LightHeader } from '../../../header/light/LightHeader';
import { Navigation } from '../../../navigation/Navigation';

/* eslint-disable camelcase */
interface CustomWindow extends Window {
  load_recaptcha_api: boolean;
}
/* eslint-enable camelcase */

declare let window: CustomWindow;

const loadCaptchaApi: boolean = window.load_recaptcha_api;

export const SignUpUserCaptcha: FC = () => (
  <>
    <LightHeader source="nav-signup">
      <Navigation />
    </LightHeader>
    <div className="content">
      <PageContainer classNames="signup-user">
        <Page>
          <div className="signup-user__discovery">
            <SignUpDiscovery />
          </div>
          <div className="signup-user__form">
            <SignUpForm />
            {loadCaptchaApi && <SignUpCaptcha />}
          </div>
        </Page>
      </PageContainer>
    </div>
  </>
);
